import { PropertiesPanelControl, PropertiesPanelLabel, PropertiesPanelProperty, PropertiesPanelPropertyContent } from './propertiesPanelProperty';
import React, { useRef } from 'react';
import { FileInput } from '../input';
import { Icon } from '../icon';
import TrashIcon from '../icons/trash-alt.svg';
import styled from 'styled-components';
import { T } from '../helpers/helpers';
import { useDropdown } from '../hooks/useDropdown';
import { Spinner } from '../spinner';

const ImagesPreviewsContainer = styled(PropertiesPanelPropertyContent)`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 10px;
`;

const PreviewImage = styled.img`
    width: 40px;
    height: 40px;
    object-fit: cover;
    cursor: pointer;
`;

const DropdownImage = styled.img`
    width: 100px;
`;
type PreviewProps = {
    fileName: string;
    src: string;
    alt: string;
};
const Preview: React.FC<PreviewProps> = ({ fileName, src, alt }) => {
    const [setOpen, _, isOpen, Dropdown] = useDropdown();
    return (
        <div>
            <PreviewImage src={src} alt={alt} onClick={(e) => setOpen(e.currentTarget)} />
            {isOpen && (
                <Dropdown>
                    {fileName}
                    <br />
                    <br />
                    <DropdownImage src={src} alt={alt} />
                </Dropdown>
            )}
        </div>
    );
};

type Image = {
    fileName: string;
    src: string;
};
export type PropertiesPanelImagePropertyProps = {
    id: string;
    label: React.ReactNode;
    images: Image[] | null;
    onUpload?: (files: FileList | null) => void;
    onDelete?: () => void;
    disabled?: boolean;
    loading?: boolean;
    accept?: string;
};
export const PropertiesPanelImageProperty: React.FC<PropertiesPanelImagePropertyProps> = ({
    id,
    label,
    images,
    onUpload,
    onDelete,
    disabled,
    loading,
    accept = 'images/*'
}) => {
    var fileInputRef = useRef<{ reset: () => void }>(null);

    return (
        <PropertiesPanelProperty>
            <PropertiesPanelLabel htmlFor={`${id}-input`}>{label}</PropertiesPanelLabel>
            <PropertiesPanelControl>
                {loading && <Spinner />}
                {!loading && (
                    <FileInput
                        ref={fileInputRef}
                        multiple
                        label={T._('Upload', 'Admin')}
                        onChange={(files) => {
                            onUpload?.(files);
                            fileInputRef!.current!.reset();
                        }}
                        disabled={disabled}
                        accept={accept}
                    />
                )}
                {!loading && !!images?.length && (
                    <Icon $hoverable onClick={onDelete} disabled={disabled}>
                        <TrashIcon />
                    </Icon>
                )}
                {!loading && !!images && images.length === 1 && (
                    <Preview key={images[0].fileName} fileName={images[0].fileName} src={images[0].src} alt={images[0].fileName} />
                )}
            </PropertiesPanelControl>
            {!loading && !!images && images.length > 1 && (
                <ImagesPreviewsContainer>
                    {images.map((image) => (
                        <Preview key={image.fileName} fileName={image.fileName} src={image.src} alt={image.fileName} />
                    ))}
                </ImagesPreviewsContainer>
            )}
        </PropertiesPanelProperty>
    );
};
